import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { ModalsManager } from '@/components/modals/modalsManager';
import { YStack } from '@/components/ui/layout/layout';
import { SearchInput } from '@/components/ui/SearchInput';
import { SidePanel } from '@/design-system-v2/side-panel';
import { SidebarRow } from '@/design-system-v2/sidebar-row';
import { FEATURES, hasFeature } from '@/features/feature-flags';
import { CreateSpriteModal } from '@/features/sprites/sprite-create';

import { SPRITE_TYPE_FILTER_OPTIONS } from './sprite-presentation';
import { spritesStore } from './sprites.store';

export const SpritesSearchButton = observer(() => {
  const open = spritesStore.searchOpen || !!spritesStore.searchQuery;
  return (
    <SidePanel.Action
      icon={Icons.search}
      label="Search files"
      active={open}
      aria-pressed={open}
      onClick={() => spritesStore.setSearchOpen(!open)}
    />
  );
});

export const SpritesViewToggle = observer(() => {
  const isGrid = spritesStore.viewMode === 'grid';
  return (
    <SidePanel.Action
      icon={isGrid ? Icons.list : Icons.layoutGrid}
      label={isGrid ? 'Show as list' : 'Show as grid'}
      onClick={() => spritesStore.setViewMode(isGrid ? 'list' : 'grid')}
    />
  );
});

export const SpritesSidebar = observer(() => {
  const filters = spritesStore.typeFilters;
  const searchOpen = spritesStore.searchOpen || !!spritesStore.searchQuery;

  return (
    <>
      {searchOpen && (
        <SidePanel.Toolbar>
          <SearchInput
            autoFocus
            value={spritesStore.searchQuery}
            onChange={(query) => spritesStore.setSearchQuery(query)}
            placeholder="Search files..."
            aria-label="Search files"
          />
        </SidePanel.Toolbar>
      )}
      {hasFeature(FEATURES.SPRITES) && (
        <SidePanel.PrimaryAction>
          <SidebarRow.Button
            leading={<SidebarRow.AddIcon />}
            onClick={() => ModalsManager.show(CreateSpriteModal, {})}
          >
            New file
          </SidebarRow.Button>
        </SidePanel.PrimaryAction>
      )}
      <YStack className="min-h-0 flex-1 gap-0.5 overflow-y-auto scrollbar-hide">
        <SidebarRow.Button
          leading={<SidebarRow.Icon icon={Icons.folder} />}
          selected={filters.length === 0}
          onClick={() => spritesStore.clearTypeFilters()}
        >
          All files
        </SidebarRow.Button>
        {SPRITE_TYPE_FILTER_OPTIONS.map(({ value, label, Icon }) => {
          return (
            <SidebarRow.Button
              key={value}
              leading={<SidebarRow.Icon icon={Icon} />}
              selected={filters.length === 1 && filters[0] === value}
              onClick={() => spritesStore.showOnlyType(value)}
            >
              {label}
            </SidebarRow.Button>
          );
        })}
      </YStack>
    </>
  );
});
